import { connect } from 'react-redux';
import { getAllCameraEvents } from '../../modules/nodes';
// import { getNodesArray } from '../../modules/nodes';
import CameraEventList from './CameraEventList';

export default connect(
  state => ({ nodes: getAllCameraEvents(state) }),
)(CameraEventList)
